/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileFormatTxtIcon20Solid = forwardRef('FileFormatTxtIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.988 2.586A2 2 0 0 0 11.573 2H6a3 3 0 0 0-3 3v2h13.954a2 2 0 0 0-.54-.988l-3.426-3.426Z" }),
        React.createElement("path", { d: "M6 18a3 3 0 0 1-3-3h14a3 3 0 0 1-3 3H6Z" }),
        React.createElement("path", { d: "M6.88 8.17H2.208v1.112h1.68v4.568h1.296V9.282H6.88V8.17Z" }),
        React.createElement("path", { d: "m12.878 13.85-2.096-3.024 1.864-2.656h-1.44L10.03 9.906 8.854 8.17H7.39l1.856 2.648-2.088 3.032h1.424l1.432-2.08 1.416 2.08h1.448Z" }),
        React.createElement("path", { d: "M17.833 8.17h-4.672v1.112h1.68v4.568h1.296V9.282h1.696V8.17Z" })));
});
